export default {
    name: 'inputsfinalized',
    component: () => import(/* webpackChunkName: "inputs-finalized-layout" */ '@/modules/inputs/finalized/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.inputs.finalized.index',
            component: () => import(/* webpackChunkName: "inputs-finalized-index" */ '@/modules/inputs/finalized/views/Index'),
        },
        {
            path: ':id/placed',
            name: 'dashboard.inputs.finalized.placed',
            component: () => import(/* webpackChunkName: "inputs-finalized-placed" */ '@/modules/inputs/finalized/views/Placed'),
        },
        {
            path: ':id/view',
            name: 'dashboard.inputs.finalized.view',
            component: () => import(/* webpackChunkName: "inputs-finalized-view" */ '@/modules/inputs/finalized/views/Print'),
        },
    ]
}